<template>
    <el-card class="box-card">
        <div class="component-content">
            <el-tabs type="border-card">
                <el-tab-pane label="兑换码批次">
                    <el-button @click="showAllExchangeSequence()">刷新批次情况</el-button>
                    <el-table :data="sequences" border style="margin-top:20px;width: 100%">
                        <el-table-column prop="id" label='批次id'>
                        </el-table-column>
                        <el-table-column prop="giftId" label='礼包id'>
                        </el-table-column>
                        <el-table-column label='兑换码类型'>
                            <template v-slot="scope">
                                <blockquote v-if="scope.row.exchangeType === 1">
                                    公共兑换码
                                </blockquote>
                                <blockquote v-if="scope.row.exchangeType === 2">
                                    兑换码
                                </blockquote>
                                <blockquote v-if="scope.row.exchangeType === 3">
                                    白名单兑换码
                                </blockquote>
                            </template>
                        </el-table-column>
                        <el-table-column label='状态'>
                            <template v-slot="scope">
                                <blockquote v-if="scope.row.activeStatus === 0">
                                    产出中
                                </blockquote>
                                <blockquote v-if="scope.row.activeStatus === 1">
                                    启用
                                </blockquote>
                                <blockquote v-if="scope.row.activeStatus === 2">
                                    已停用
                                </blockquote>
                            </template>
                        </el-table-column>
                        <el-table-column label="奖励列表">
                            <template v-slot="scope">
                                <span>{{scope.row.rewards}}</span>
                                <span class="reward-text" v-if="scope.row.id == rewardsCNId">({{rewardsCN}})</span>
                                <el-button type="text" @click="rewardsToCN(scope.row.rewards,scope.row.id)" v-if="scope.row.id !== rewardsCNId">展示中文</el-button>
                            </template>
                        </el-table-column>
                        <el-table-column prop="createTime" label='生成时间'>
                        </el-table-column>
                        <el-table-column prop="gmtValid" label='生效时间'>
                        </el-table-column>
                        <el-table-column prop="gmtEnd" label='失效时间'>
                        </el-table-column>
                        <el-table-column prop="totalCount" label='生成总量'>
                        </el-table-column>
                        <el-table-column prop="activeCount" label='已生成总量'>
                        </el-table-column>
                        <el-table-column prop="remainCount" label='剩余生成数量'>
                        </el-table-column>
                        <el-table-column prop="genSerialNum" label='最大生成序号'>
                        </el-table-column>
                        <el-table-column prop="mark" label='备注'>
                        </el-table-column>
                        <el-table-column fixed="right" label='操作' width="218">
                            <template v-slot="scope">
                                <el-button size="small" type="primary" @click="insertCodeBySequence(scope.row.id)" v-if="scope.row.remainCount > 0&&scope.row.exchangeType === 2">生成</el-button>
                                <el-button size="small" type="success" @click="exportSequence(scope.row.id)" v-if="scope.row.activeStatus === 1">导出</el-button>
                                <el-button size="small" type="warning" @click="banSequence(scope.row.id)" v-if="scope.row.activeStatus === 1">停用</el-button>
                                <el-button size="small" type="danger" @click="deleteSequence(scope.row.id)" v-if="scope.row.activeStatus === 2">删除</el-button>
                                <el-button size="small" type="primary" @click="enabledSequence(scope.row.id)" v-if="scope.row.activeStatus === 2">启用</el-button>
                                <el-button size="small" type="primary" @click="updateSequence(scope.row.id,scope.row.remainCount,scope.row.gmtEnd,scope.row.exchangeType)" v-if="scope.row.activeStatus === 1">修改</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                    <div class="block">
                        <el-pagination
                                layout="total, sizes, prev, pager, next, jumper"
                                :total=querySequenceForm.totalElements
                                :page-sizes="[10, 20, 30, 50]"
                                :page-size="querySequenceForm.size"
                                :current-page.sync="querySequenceForm.page"
                                @size-change="handleQuerySequenceCurrentChange"
                                @current-change="handleQuerySequenceSizeChange" >
                        </el-pagination>
                    </div>

                    <el-card>
                        <div slot="header" class="clearfix">
                            <span>兑换码 - 基础信息</span>
                        </div>
                        <el-form label-position="left" label-width="100px">
                            <el-form-item label='类型：'>
                                <el-select v-model="createForm.exchangeType" placeholder='选择类型'>
                                    <el-option v-for="item in typeOptions" :key="item.value" :label="item.label" :value="item.value">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label='渠道：'>
                                <el-switch
                                        v-model="createForm.isAllServer"
                                        active-color="#13ce66"
                                        inactive-color="#ff4949"
                                        active-text="全部"
                                        inactive-text="指定">
                                </el-switch>
                                <div style="margin: 15px 0;"></div>
                                <div v-if="!createForm.isAllServer">
                                    <el-checkbox :indeterminate="createForm.isIndeterminate" v-model="createForm.checkAll" @change="handleCheckAllChange">全选</el-checkbox>
                                    <div style="margin: 15px 0;"></div>
                                    <el-checkbox-group v-model="createForm.checkServerList" @change="handleCheckedServersChange">
                                        <el-checkbox v-for="item of channelOptions" :key="item.value"  :label="item.value">
                                            {{item.value+'('+item.channel+')'}}
                                        </el-checkbox>
                                    </el-checkbox-group>
                                </div>
                            </el-form-item>

                            <el-form-item label="时区：">
                                <el-select v-model="localZoneTime">
                                    <el-option
                                        v-for="localZoneTimeItem in localZoneTimeOptions"
                                        :key="localZoneTimeItem.value"
                                        :value="localZoneTimeItem.value"
                                        :label="localZoneTimeItem.label">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label='生效时间：'>
                                <el-date-picker v-model="localGmtValid" @change="getGmtValid()" type="datetime" :picker-options="pickerOptions"
                                                placeholder="选择日期时间" value-format="yyyy-MM-dd HH:mm:ss">
                                </el-date-picker>
                                <template v-if="localGmtValid">
                                    <span class="code-tip">本地时间:{{localGmtValid2}}(utc{{localZoneTime}})</span>
                                    <span>||</span>
                                    <span class="code-tip">服务器时间:{{createForm.gmtValid}}(utc{{serverZoneTime}})</span>
                                </template>
                            </el-form-item>

                            <el-form-item label='失效时间：'>
                                <el-date-picker v-model="localGmtEnd" @change="getGmtEnd()" type="datetime" :picker-options="pickerOptionsDisabled"
                                                placeholder="选择日期时间" value-format="yyyy-MM-dd HH:mm:ss">
                                </el-date-picker>
                                <template v-if="localGmtEnd">
                                    <span class="code-tip">本地时间:{{localGmtEnd3}}(utc{{localZoneTime}})</span>
                                    <span>||</span>
                                    <span class="code-tip">服务器时间:{{createForm.gmtEnd}}(utc{{serverZoneTime}})</span>
                                </template>
                            </el-form-item>

                            <el-form-item label='礼包Id'>
                                <el-autocomplete class="inline-input" v-model="createForm.giftId" :fetch-suggestions="giftSearch" popper-class="gift-autocomplete"
                                                 placeholder="请输礼包id" :trigger-on-focus="true" @select="handleGiftSelect">
                                    <i class="el-icon-edit el-input__icon"
                                            slot="suffix"
                                            @click="handleIconClick">
                                    </i>
                                    <template v-slot="props">
                                        <div class="name">{{ props.item.id }}</div>
                                        <span class="addr">{{ props.item.content }}</span>
                                    </template>
                                </el-autocomplete>
                            </el-form-item>

                            <el-form-item label='备注：'>
                                <el-input type="textarea" autosize placeholder="请输入备注" v-model="createForm.mark">
                                </el-input>
                            </el-form-item>

                            <el-form-item label='密钥信息：' v-if="createForm.exchangeType == 1">
                                <el-input v-model="createForm.textCode" placeholder='请输入公用兑换码文案 - 该兑换码截止时间前,玩家输入相同文案即可兑换'>
                                    <template v-if="showTips == true" v-slot="prepend"> 已存在兑换码</template>
                                </el-input>
                            </el-form-item>

                            <el-form-item label='生成数量' v-if="createForm.exchangeType == 1">
                                <span>1</span>
                            </el-form-item>

                            <el-form-item label='谨慎开关：' v-if="createForm.exchangeType != 1">
                                <el-switch v-model="isDetail" active-color="#13ce66" inactive-color="#ff4949"></el-switch>
                            </el-form-item>

                            <el-form-item label='生成数量：' v-if="createForm.exchangeType != 1">
                                <template v-if="isDetail == false">
                                    <el-input-number :min="1" :max="1000000" v-model.number="createForm.totalCount" />
                                    <span>快捷选项：</span>
                                    <el-button size="mini" @click="createForm.totalCount = createForm.totalCount + 10000">一万</el-button>
                                    <el-button size="mini" @click="createForm.totalCount = createForm.totalCount + 100000">十万</el-button>
                                    <el-button size="mini" @click="createForm.totalCount = 1000000">百万</el-button>
                                </template>

                                <template v-if="isDetail == true">
                                    <el-input-number v-model="num.f" :min="0" :max="9" placeholder='请输入十万位'></el-input-number>
                                    <span>十万</span>
                                    <el-input-number v-model="num.e" :min="0" :max="9" placeholder='请输入万位'></el-input-number>
                                    <span>万</span>
                                    <el-input-number v-model="num.d" :min="0" :max="9" placeholder='请输入千位'></el-input-number>
                                    <span>千</span>
                                    <el-input-number v-model="num.c" :min="0" :max="9" placeholder='请输入百位'></el-input-number>
                                    <span>百</span>
                                    <el-input-number v-model="num.b" :min="0" :max="9" placeholder='请输入十位'></el-input-number>
                                    <span>十</span>
                                    <el-input-number v-model="num.a" :min="0" :max="9" placeholder='请输入个位'></el-input-number>
                                    <span>个</span>
                                </template>
                            </el-form-item>
                            <el-form-item label='生成数量预览:' v-if="createForm.exchangeType != 1">
                                <template v-if="isDetail == true">
                                    {{num.a*1 + num.b*10 + num.c*100  + num.d*1000 + num.e*10000 + num.f*100000}}
                                    （
                                    <template v-if="num.g == 10">1 百万</template>
                                    <template v-if="num.f >= 0">{{num.f }}十万</template>
                                    <template v-if="num.e >= 0">{{num.e }}万 </template>
                                    <template v-if="num.d >= 0">{{num.d }}千 </template>
                                    <template v-if="num.c >= 0">{{num.c }}百 </template>
                                    <template v-if="num.b >= 0">{{num.b }}十 </template>
                                    <template v-if="num.a >= 0">{{num.a }}个 </template>
                                    ）
                                </template>
                                <template v-if="isDetail == false">
                                    {{createForm.totalCount}}
                                    （
                                    <template v-if="createForm.totalCount == 1000000"> 1 百万</template>
                                    <template v-if="createForm.totalCount >= 100000">
                                        {{parseInt((createForm.totalCount % 1000000) / 100000) }} 十万
                                    </template>
                                    <template v-if="createForm.totalCount >= 10000">
                                        {{parseInt((createForm.totalCount % 100000) / 10000) }} 万
                                    </template>
                                    <template v-if="createForm.totalCount >= 1000">
                                        {{parseInt((createForm.totalCount % 10000) / 1000) }}千
                                    </template>
                                    <template v-if="createForm.totalCount >= 100">
                                        {{parseInt((createForm.totalCount % 1000) / 100) }}百
                                    </template>
                                    <template v-if="createForm.totalCount >= 10">
                                        {{parseInt((createForm.totalCount % 100) / 10) }}十
                                    </template>
                                    <template>
                                        {{parseInt(createForm.totalCount % 10) }} 个
                                    </template>
                                    ）
                                </template>
                            </el-form-item>

                            <el-form-item>
                                <el-button type="primary" @click="createSequence" >创建批次</el-button>
<!--                                <el-button type="primary" v-if="createForm.exchangeType == 1" @click="createCode">创建公用兑换码</el-button>-->
                                <el-button>取消</el-button>
                            </el-form-item>
                        </el-form>

                    </el-card>



<!--                    <el-card v-if="createForm.exchangeType != 1">
                        <div slot="header" class="clearfix">
                            <span>兑换码 - 批次信息</span>
                        </div>
                        <el-form label-position="left" label-width="80px">
                            <el-form-item label='批次'>
                                <el-input v-model="createForm.pici" placeholder='请输入批次'>
                                    <template v-if="showTips == true" v-slot="prepend"> 已存在批次</template>
                                </el-input>
                            </el-form-item>

                        </el-form>
                    </el-card>-->

                </el-tab-pane>

                <el-tab-pane label="兑换码列表">
                    <el-card>
                        <div slot="header" class="clearfix">
                            <span>搜索条件栏</span>
                        </div>
                        <el-select v-model="queryCodeForm.exchangeType" placeholder="请选择兑换码类别">
                            <el-option
                                v-for="item in typeOptions"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                        <el-input v-model="queryCodeForm.sequenceId" placeholder="请输入批次ID" style="width: 200px"></el-input>
                        <el-button type="success" @click="queryCode()">刷新</el-button>
                    </el-card>
                    <el-card >
                        <el-table :data="publicCodeList" border style="margin-top:20px;width: 100%">
                            <el-table-column prop="id" label='兑换码id'>
                            </el-table-column>
                            <el-table-column prop="giftId" label='礼包id'>
                            </el-table-column>
                            <el-table-column prop="textCode" label='兑换密钥'>
                            </el-table-column>
                            <el-table-column label='兑换码类型'>
                                <template v-slot="scope">
                                    <blockquote v-if="scope.row.exchangeType === 1">
                                        公共兑换码
                                    </blockquote>
                                    <blockquote v-if="scope.row.exchangeType === 2">
                                        兑换码
                                    </blockquote>
                                    <blockquote v-if="scope.row.exchangeType === 3">
                                        白名单兑换码
                                    </blockquote>
                                </template>
                            </el-table-column>
                            <el-table-column label='状态'>
                                <template v-slot="scope">
                                    <blockquote v-if="scope.row.status == 0">
                                        产出中
                                    </blockquote>
                                    <blockquote v-if="scope.row.status == 1">
                                        启用
                                    </blockquote>
                                    <blockquote v-if="scope.row.status == 2">
                                        已作废
                                    </blockquote>
                                </template>
                            </el-table-column>
                            <el-table-column label="奖励列表">
                                <template v-slot="scope">
                                    <span>{{scope.row.rewards}}</span>
                                    <span class="reward-text" v-if="scope.row.id == rewardsCNId">({{rewardsCN}})</span>
                                    <el-button type="text" @click="rewardsToCN(scope.row.rewards,scope.row.id)" v-if="scope.row.id !== rewardsCNId">展示中文</el-button>
                                </template>
                            </el-table-column>
                            <el-table-column prop="gmtCreate" label='生成时间'>
                            </el-table-column>
                            <el-table-column prop="gmtValid" label='生效时间'>
                            </el-table-column>
                            <el-table-column prop="gmtEnd" label='失效时间'>
                            </el-table-column>
                            <el-table-column prop="channel" label='渠道'>
                            </el-table-column>
                        </el-table>
                        <div class="block">
                            <el-pagination
                                layout="total, sizes, prev, pager, next, jumper"
                                :total=queryCodeForm.totalElements
                                :page-sizes="[10, 20, 30, 50]"
                                :page-size=queryCodeForm.size
                                :current-page.sync="queryCodeForm.page"
                                @size-change="handleQueryCodeSizeChange"
                                @current-change="handleQueryCodeCurrentChange" >
                            </el-pagination>
                        </div>
                    </el-card>
                </el-tab-pane>

                <el-tab-pane label="礼包">
                    <el-button @click="showGifts()">刷新礼包列表</el-button>
                    <el-button type="success"  @click="">导出全部礼包</el-button>
                    <el-card>
                        <div slot="header" class="clearfix">
                            <span>礼包列表</span>
                        </div>
                        <el-table :data="gifts" border style="margin-top:20px;width: 100%">
                            <el-table-column prop="id" label='礼包id'>
                            </el-table-column>
                            <el-table-column prop="content" label='内容'>
                            </el-table-column>
                            <el-table-column prop="reward" label='奖励串'>
                            </el-table-column>
                            <el-table-column prop="createTime" label='创建时间'>
                            </el-table-column>
                            <el-table-column fixed="right" label='操作' width="150">
                                <template v-slot="scope">
<!--                                    <el-button size="small" type="success" @click="afterGift(scope.row.id)">修改</el-button>-->
                                    <el-button size="small" type="warning" @click="deleteGift(scope.row.id)">废弃</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                        <div class="block">
                            <el-pagination
                                    layout="total, sizes, prev, pager, next, jumper"
                                    :total=queryGiftForm.totalElements
                                    :page-sizes="[10, 20, 30, 50]"
                                    :page-size=queryGiftForm.size
                                    :current-page.sync="queryGiftForm.page"
                                    @size-change="handleQueryGiftCurrentChange"
                                    @current-change="handleQueryGiftSizeChange" >
                            </el-pagination>
                        </div>
                    </el-card>
                    <el-card>
                        <div slot="header" class="clearfix">
                            <span>创建新礼包</span>
                        </div>
                        <el-form label-position="left" label-width="80px">
                            <el-form-item label='ID'>
                                <el-input v-model="createGiftForm.id" placeholder='请输入ID'>
                                    <template v-if="showTips == true" v-slot="prepend"> 已存在ID</template>
                                </el-input>
                            </el-form-item>
                            <el-form-item label='内容'>
                                <el-input v-model="createGiftForm.content" placeholder='请输入内容'>
                                    <template v-if="showTips == true" v-slot="prepend"> 已存在批次</template>
                                </el-input>
                            </el-form-item>
                            <el-form-item label='奖励'>
                                <el-input v-model="createGiftForm.reward" placeholder='请输入奖励'>
                                    <template v-if="showTips == true" v-slot="prepend"> 已存在批次</template>
                                </el-input>
                            </el-form-item>
                            <el-button type="primary"  @click="createGift()">创建新礼包</el-button>
                        </el-form>
                    </el-card>
                    <el-card>
                        <div slot="header" class="clearfix">
                            <span>奖励串数据</span>
                        </div>
                        <el-input type="textarea" v-model="rewardStr"></el-input>
                    </el-card>
                    <el-card>
                        <div slot="header" class="clearfix">
                            <span>子奖励</span>
                            <el-button-group>
                                <el-button @click="addReward()">添加子奖励</el-button>
                                <el-button type="danger" @click="deleteReward()">删除子奖励</el-button>
                                <el-button type="success"
                                        @click="generateRewardData()"
                                        >生成奖励串
                                </el-button>
                            </el-button-group>
                        </div>
                        <template v-for="(rd, rdIdx) in rewardGroups[currentRewardGroupIdx]">
                            <el-button :key="rdIdx"
                                       :class="{ 'el-button--success': rdIdx === currentRewardIdx }"
                                       size="mini" @click="selectReward(rdIdx)" plain>{{ rdIdx + 1 }}
                            </el-button>
                        </template>
                    </el-card>

                    <el-card>
                        <div slot="header" class="clearfix">
                            <span>奖励串详情</span>
                        </div>
                        <div v-if="currentRewardGroupIdx!==null&&currentRewardIdx!==null">
                            <div v-for="(item,index) in rewardGroups[currentRewardGroupIdx]" style="margin-bottom: 20px;">
                                {{item.length!==0?((index+1)+ ': ' + item):''}}
                                <span>{{item.length!==0?('('+ finalContentCNArr[index]+ ')'):''}}</span>
                            </div>
                        </div>
                    </el-card>

                    <common-editor :currentReward="currentReward" :currentRewardIdx="currentRewardIdx"  @reward="getReward"></common-editor>

<!--                    <div class="confirm-btn">
                        <el-button size="medium" type="primary" @click="codeGenerator()">生成</el-button>
                    </div>-->
                </el-tab-pane>

                <el-tab-pane label="兑换码统计">
                    <el-card>
                        <div slot="header" class="clearfix">
                            <span>选择模式：
                                <el-radio-group v-model="queryForm.mode" size="small">
                                    <el-radio-button label="detail">查看兑换码详情</el-radio-button>
                                    <el-radio-button label="sumBySequence">统计批次情况</el-radio-button>
                                    <el-radio-button label="sumByGift">统计子类型情况</el-radio-button>
                                    <el-radio-button label="sumByMark">统计备注情况</el-radio-button>
                                </el-radio-group>
                            </span>
                        </div>
                        <el-form :inline="true">
                            <el-form-item label='兑换码' v-if="queryForm.mode == 'detail'">
                                <el-input v-model="queryForm.codeStr" placeholder='请输入兑换码'></el-input>
                            </el-form-item>

                            <el-form-item label='类型' v-if="queryForm.mode == 'sumBySequence' || queryForm.mode == 'sumByGift' ||queryForm.mode == 'sumByMark' ">
                                <el-select v-model="queryForm.codeType" placeholder='选择类型'>
                                    <el-option v-for="item in typeOptions" :key="item.value" :label="item.label" :value="item.value"
                                        :disabled="item.value == 1">
                                    </el-option>
                                </el-select>
                            </el-form-item>

                            <el-form-item label='批次' v-if="queryForm.mode == 'sumBySequence'">
                                <el-select v-model="queryForm.pici" placeholder='选择批次'>
                                    <el-option v-for="item in sequences" :key="item.id" :label="item.id" :value="item.id">
                                    </el-option>
                                </el-select>
                            </el-form-item>

                            <el-form-item label='子类型' v-if="queryForm.mode == 'sumBySequence'">
                                <el-select v-model="queryForm.subType" placeholder='选择子类型'>
                                    <el-option v-for="(item,index) in subTypeItems" :key="index" :label="item.value"
                                        :value="item.value">
                                    </el-option>
                                </el-select>
                            </el-form-item>

                            <el-form-item label='备注' v-if="queryForm.mode == 'sumByMark'">
                                <el-select v-model="queryForm.mark" placeholder='请输入备注'>
                                    <el-option v-for="(item,index) in markItems" :key="index" :label="item.value"
                                        :value="item.value">
                                    </el-option>
                                </el-select>
                            </el-form-item>

                            <el-form-item v-if="queryForm.mode == 'detail'">
                                <el-button size="small" type="primary" @click="getExchangeCode()">查询兑换码情况</el-button>
                                <el-button size="small" type="danger" @click="banExchangeCode(codeData.id)">废弃单个兑换码</el-button>
                            </el-form-item>

                            <el-form-item v-if="queryForm.mode == 'sumBySequence' || queryForm.mode == 'sumByGift' ||queryForm.mode == 'sumByMark' ">
                                <el-button size="small" type="primary" @click="sumExchangeCode()">统计兑换码情况</el-button>
                                <el-button size="small" type="warning" @click="exportCode()">导出所有符合条件的兑换码</el-button>
                                <el-button size="small" type="danger" @click="banSequenceByPicis()">废弃所有符合条件的兑换码</el-button>
                            </el-form-item>
                        </el-form>
                    </el-card>
                    <el-card v-if="queryForm.mode == 'detail'">
                        <div slot="header" class="clearfix">
                            <span>兑换码详细信息</span>
                        </div>
                        <el-form label-position="left" :inline="true"  class="player-form">
                            <el-row>
                                <el-col :span="3">
                                    <el-form-item label="兑换码:">
                                        {{codeData.textCode}}
                                    </el-form-item>
                                </el-col>

                                <el-col :span="3">
                                    <el-form-item label="奖励:">
                                        {{codeData.rewards}}
                                    </el-form-item>
                                </el-col>
                                <el-col :span="3">
                                    <el-form-item label="状态:">
                                        {{codeData.status}}
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="3">
                                    <el-form-item label="类型:">
                                        {{codeData.exchangeType}}
                                    </el-form-item>
                                </el-col>
                                <el-col :span="3">
                                    <el-form-item label="礼包Id:">
                                        {{codeData.giftId}}
                                    </el-form-item>
                                </el-col>
                                <el-col :span="3">
                                    <el-form-item label="批次号:">
                                        {{codeData.sequenceId}}
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="3">
                                    <el-form-item label="渠道:">
                                        {{codeData.channel}}
                                    </el-form-item>
                                </el-col>
                                <el-col :span="3">
                                    <el-form-item label="软删除状态:">
                                        {{codeData.enabled}}
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="3">
                                    <el-form-item label="生效时间:">
                                        {{codeData.gmtValid}}
                                    </el-form-item>
                                </el-col>
                                <el-col :span="3">
                                    <el-form-item label="创建时间:">
                                        {{codeData.gmtCreate}}
                                    </el-form-item>
                                </el-col>
                                <el-col :span="3">
                                    <el-form-item label="失效时间:">
                                        {{codeData.gmtEnd}}
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="3">
                                    <el-form-item label="已领取的用户id:" v-if="codeData.type != 1">
                                        {{codeData.user_id}}
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </el-form>
                    </el-card>

                    <el-card v-if="queryForm.mode == 'sumBySequence' || queryForm.mode == 'sumByGift' ||queryForm.mode == 'sumByMark' ">
                        <div slot="header" class="clearfix">
                            <span>兑换码统计信息</span>
                        </div>
                        <el-form label-position="left">
                            <el-form-item label="兑换码总量:">
                                {{codeSumData.totalCount}}
                            </el-form-item>
                            <el-form-item label="可用总量:">
                                {{codeSumData.activeCount}}
                            </el-form-item>
                            <el-form-item label="已用总量:">
                                {{codeSumData.remindCount}}
                            </el-form-item>
                        </el-form>
                    </el-card>

                </el-tab-pane>

                <el-tab-pane label="兑换码兑换记录">
                  <el-table :data="exchangeCodeHistory" border style="margin-top:20px;width: 100%">
                    <el-table-column prop="id" label='id'>
                    </el-table-column>
                    <el-table-column prop="giftId" label='giftId'>
                    </el-table-column>
                    <el-table-column prop="userId" label='用户Id'>
                    </el-table-column>
                    <el-table-column prop="textCode" label='兑换码'>
                    </el-table-column>
                    <el-table-column prop="createTime" label='日期'>
                    </el-table-column>
                  </el-table>
                    <div class="block">
                        <el-pagination
                                layout="total, sizes, prev, pager, next, jumper"
                                :total=queryExchangeHistoryForm.totalElements
                                :page-sizes="[10, 20, 30, 50]"
                                :page-size=queryExchangeHistoryForm.size
                                :current-page.sync="queryExchangeHistoryForm.page"
                                @size-change="handleQueryExchangeCodeHistoryCurrentChange"
                                @current-change="handleQueryExchangeCodeHistorySizeChange" >
                        </el-pagination>
                    </div>
                </el-tab-pane>

<!--                修改批次对话框-->
                <el-dialog
                        title="修改批次信息"
                        :visible.sync="updateSequenceForm.dialogVisible"
                        width="30%"
                >
                    <el-form label-position="left" label-width="100px">
                        <el-form-item label="时区：">
                            <el-select v-model="localZoneTime2">
                                <el-option
                                    v-for="localZoneTimeItem in localZoneTimeOptions"
                                    :key="localZoneTimeItem.value"
                                    :value="localZoneTimeItem.value"
                                    :label="localZoneTimeItem.label">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label='失效时间：'>
                            <el-date-picker v-model="localGmtEnd2" @change="getGmtEnd2()" type="datetime" :picker-options="pickerOptions"
                                            placeholder="选择日期时间" value-format="yyyy-MM-dd HH:mm:ss">
                            </el-date-picker>
                            <template v-if="localGmtEnd2">
                                <span class="code-tip">本地时间:{{localGmtEnd4}}(utc{{localZoneTime2}})</span>
                                <span>||</span>
                                <span class="code-tip">服务器时间:{{updateSequenceForm.gmtEnd}}(utc{{serverZoneTime}})</span>
                            </template>
                        </el-form-item>
                        <el-form-item label='补充数量：' v-if="updateSequenceForm.exchangeType===2">
                            <el-input-number :min="0" :max="1000000" v-model.number="updateSequenceForm.remainCount" />
                        </el-form-item>
                    </el-form>
                    <span slot="footer" class="dialog-footer">
                            <el-button @click="updateSequenceForm.dialogVisible = false">取 消</el-button>
                            <el-button type="primary" @click="confirmUpdateSequence">确 定</el-button>
                            </span>
                </el-dialog>
            </el-tabs>
        </div>
    </el-card>
</template>

<style lang="less">
.gift-autocomplete {
    li {
        line-height: normal;
        padding: 7px;

        .name {
            text-overflow: ellipsis;
            overflow: hidden;
        }
        .addr {
            font-size: 12px;
            color: #b4b4b4;
        }

        .highlighted .addr {
            color: #ddd;
        }
    }
}
</style>

<script>
    import paginationController from '../../mixins/pagination'
    import actionConfirm from '../../mixins/action_confirm'
    import exchangeApi from '../../service/exchange_api'
    import commonEditor from '../../components/common_editor';
    import Utils from '../../lib/utils';
    import {
        mapState
    } from 'vuex';

    export default {
        name: "exchange_code",
        components: {
            commonEditor
        },
        data() {
            return {
                title: this.$route.meta.title,
                serverZoneTime: Global_Config_Yunwei.serverZoneTime,
                sequences: [],
                markItems: [],
                gifts:[],
                queryForm: {
                    mode: 'detail',
                    codeStr: '',
                    pici: '',
                    codeType: '2',
                    subType: ''
                },
                querySequenceForm:{
                    totalPages:0,
                    totalElements:0,
                    page:0,
                    size:10,
                },
                publicCodeList:[],
                queryCodeForm:{
                    totalPages:0,
                    totalElements:0,
                    page:0,
                    size:10,
                    exchangeType: "",
                    sequenceId:null
                },
                queryGiftForm:{
                    totalPages:0,
                    totalElements:0,
                    page:0,
                    size:10,
                },
                queryExchangeHistoryForm: {
                    textCode:'',
                    userId:null,
                    sequenceId:null,
                    totalPages:0,
                    totalElements:0,
                    page:0,
                    size:10,
                },
                codeData: {},
                codeSumData: {},
                isDetail: false,
                num: {
                    a: 0,
                    b: 0,
                    c: 0,
                    d: 0,
                    e: 0,
                    f: 0,
                },

                createForm: {
                    exchangeType: "",
                    gmtValid: "",
                    gmtEnd:"",
                    totalCount: 0,
                    giftId: "",
                    mark: "",
                    rewards: "",
                    textCode: "",
                    isAllServer:true,
                    checkServerList:[],
                    checkAll:false,
                    isIndeterminate:false
                },
                localZoneTime: 8,
                localZoneTime2: 8,
                localZoneTimeOptions: [
                    {
                        label: 'utc8',
                        value: 8
                    },
                    {
                        label: 'utc-5',
                        value: -5
                    }
                ],

                localGmtValid: '',
                localGmtValid2: '',
                localGmtEnd: '',
                localGmtEnd3: '',

                createGiftForm:{
                    id:"",
                    content:"",
                    reward:""
                },
                sequence: {},
                updateSequenceForm:{
                    exchangeType:0,
                    dialogVisible:false,
                    remainCount:null,
                    gmtEnd:null,
                },
                localGmtEnd2: '',
                localGmtEnd4: '',

                codeList: [],
                showTips: false,
                codesLen: 0,
                codeIndex: -1,

                pickerOptions: {
                    disabledDate(time) {
                        return time.getTime() < Date.now();
                    },
                    shortcuts: [
                        {
                            text: '明天',
                            onClick(picker) {
                                const date = new Date();
                                date.setTime(date.getTime() + 3600 * 1000 * 24);
                                picker.$emit('pick', date);
                            }
                        },
                        {
                            text: '三天后',
                            onClick(picker) {
                                const date = new Date();
                                date.setTime(date.getTime() + 3600 * 1000 * 24 * 3);
                                picker.$emit('pick', date);
                            }
                        },
                        {
                            text: '一周后',
                            onClick(picker) {
                                const date = new Date();
                                date.setTime(date.getTime() + 3600 * 1000 * 24 * 7);
                                picker.$emit('pick', date);
                            }
                        },
                        {
                            text: '一个月后',
                            onClick(picker) {
                                const date = new Date();
                                date.setTime(date.getTime() + 3600 * 1000 * 24 * 30);
                                picker.$emit('pick', date);
                            }
                        }
                    ]
                },

                typeOptions: [{
                        label: '公用兑换码',
                        value: '1'
                    },
                    {
                        label: '兑换码',
                        value: '2'
                    }
                ],
                allServer:false,
                channelOptions: [],

                exchangeCodeHistory:[],

                rewardGroups: [],
                currentRewardGroupIdx: null,
                currentRewardIdx: null,
                currentReward: null,
                finalContentCNArr:[],


                optionMap:{
                    '0':this.$t("reward_editor.39"),
                    '1':this.$t("reward_editor.40"),
                    '2':this.$t("reward_editor.41"),
                    '3':this.$t("reward_editor.42"),
                    '4':this.$t("reward_editor.43"),
                    '5':'约束性道具',
                    '6':this.$t("reward_editor.44"),
                    '7':'战纹',
                    '8':this.$t("reward_editor.46"),
                    '9':this.$t("reward_editor.47"),
                    '10':'回复类道具',
                    '11':'头像',
                    '12':'头像框',
                    '13':'宝箱',
                    '14':'皮肤',
                    '15':'时效类道具',
                },
                optionValue: '0',
                count1: '',
                count2: '',
                countSwitch: false,
                rate: 0.1,
                value: '',
                emblemEntryConfigs: [],
                emblemLevel: 1,
                emblemStage: 0,
                emblemQuality: 1,
                emblemFate:0,
                emblemFateCustomizeTags:[],
                emblemFateCustomize:100,
                emblemMainProperty: 1,
                emblemFateProperty: 51,
                editEmblemEntries:[
                    {
                        entry:[3, 0],
                        quality:0,
                        active:true
                    },
                    {
                        entry:[3, 0],
                        quality:0,
                        active:false
                    },
                    {
                        entry:[3, 0],
                        quality:0,
                        active:false
                    },
                    {
                        entry:[3, 0],
                        quality:0,
                        active:false
                    },
                    {
                        entry:[3, 0],
                        quality:0,
                        active:false
                    },
                    {
                        entry:[3, 0],
                        quality:0,
                        active:false
                    },
                ],

                rewardsCN: '',
                rewardsCNId: '',
                rewardStr:''
            }
        },
        mixins: [paginationController, actionConfirm],
        computed: {
            ...mapState({
                token: state => state.user.userInfo.loginToken,
            }),
            pickerOptionsDisabled() {
                return {
                    disabledDate(time) {
                        return time.getTime() < Date.now();
                    },
                    shortcuts: [
                        {
                            text: '明天',
                            onClick: (picker) => {
                                let gmtStarted = this.localGmtValid;
                                const date = new Date(gmtStarted);
                                date.setTime(date.getTime() + 3600 * 1000 * 24);
                                picker.$emit('pick', date);
                            }
                        },
                        {
                            text: '三天后',
                            onClick: (picker) => {
                                let gmtStarted = this.localGmtValid;
                                const date = new Date(gmtStarted);
                                date.setTime(date.getTime() + 3600 * 1000 * 24 * 3);
                                picker.$emit('pick', date);
                            }
                        },
                        {
                            text: '一周后',
                            onClick: (picker) => {
                                let gmtStarted = this.localGmtValid;
                                const date = new Date(gmtStarted);
                                date.setTime(date.getTime() + 3600 * 1000 * 24 * 7);
                                picker.$emit('pick', date);
                            }
                        },
                        {
                            text: '一个月后',
                            onClick: (picker) => {
                                let gmtStarted = this.localGmtValid;
                                const date = new Date(gmtStarted);
                                date.setTime(date.getTime() + 3600 * 1000 * 24 * 30);
                                picker.$emit('pick', date);
                            }
                        }
                    ]

                }
            },
        },
        mounted() {
            this.showAllExchangeSequence();
            this.getChannelsList();
            this.showGifts();
            this.addRewardGroup();
            this.queryCode()
            this.getUserExchangeHistory();
        },
        methods: {
            getGmtValid() {
                let self = this;
                const date = new Date(self.localGmtValid);

                let localTime = '';
                let localTimeZone = self.localZoneTime;

                localTime = date;
                self.localGmtValid2 = Utils.formatDate(localTime);

                let time = '';
                let timeZone = self.serverZoneTime;

                if (localTimeZone == -5) {
                    if (timeZone == -5) {
                        time = localTime;
                    } else if (timeZone == 8) {
                        time = self.west5TimeToEast8Time(date)
                    }
                } else if (localTimeZone == 8) {
                    if (timeZone == -5) {
                        time = self.toWest5Time(date)
                    } else if (timeZone == 8) {
                        time = localTime;
                    }
                }

                self.createForm.gmtValid = Utils.formatDate(time);
            },

            getGmtEnd() {
                let self = this;
                const date = new Date(self.localGmtEnd);

                let localTime = '';
                let localTimeZone = self.localZoneTime;

                localTime = date;
                self.localGmtEnd3 = Utils.formatDate(localTime);

                let time = '';
                let timeZone = self.serverZoneTime;

                if (localTimeZone == -5) {
                    if (timeZone == -5) {
                        time = localTime;
                    } else if (timeZone == 8) {
                        time = self.west5TimeToEast8Time(date)
                    }
                } else if (localTimeZone == 8) {
                    if (timeZone == -5) {
                        time = self.toWest5Time(date)
                    } else if (timeZone == 8) {
                        time = localTime;
                    }
                }

                self.createForm.gmtEnd = Utils.formatDate(time);
            },

            getGmtEnd2() {
                let self = this;
                const date = new Date(self.localGmtEnd2);

                let localTime = '';
                let localTimeZone = self.localZoneTime2;

                localTime = date;
                self.localGmtEnd4 = Utils.formatDate(localTime);

                let time = '';
                let timeZone = self.serverZoneTime;

                if (localTimeZone == -5) {
                    if (timeZone == -5) {
                        time = localTime;
                    } else if (timeZone == 8) {
                        time = self.west5TimeToEast8Time(date)
                    }
                } else if (localTimeZone == 8) {
                    if (timeZone == -5) {
                        time = self.toWest5Time(date)
                    } else if (timeZone == 8) {
                        time = localTime;
                    }
                }

                self.updateSequenceForm.gmtEnd = Utils.formatDate(time);
            },

            giftSearch(queryString, cb) {
                let searchData = this.gifts;
                var results = queryString ? searchData.filter(this.giftFilter(queryString)) :
                    searchData;
                // 调用 callback 返回建议列表的数据
                cb(results);
            },
            giftFilter(queryString) {
                return (gift) => {
                    return (gift.id.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
                };
            },
            handleGiftSelect(item) {
                this.createForm.giftId = item.id;
            },
            handleIconClick(ev) {
                console.log(ev);
            },
            showAllExchangeSequence() {
                let self = this;
                exchangeApi.showAllExchangeSequence({
                    token: this.token,
                    querySequenceForm:self.querySequenceForm,
                }).then(res => {
                    self.sequences = res.content;
                    self.querySequenceForm.totalPages = res.totalPages;
                    self.querySequenceForm.totalElements = res.totalElements;
                })
            },
            handleCheckAllChange(val) {
                let self = this;
                self.createForm.isIndeterminate = false;
                if(val){
                    self.channelOptions.forEach(item=>self.createForm.checkServerList.push(item.value))
                }else{
                    self.createForm.checkServerList = [];
                }
            },
            handleCheckedServersChange(value) {
                let checkedCount = value.length;
                this.createForm.checkAll = checkedCount === this.channelOptions.length;
                this.createForm.isIndeterminate = checkedCount > 0 && checkedCount < this.channelOptions.length;
            },
            getChannelsList(){
                let self = this;
                exchangeApi.getAllChannel({
                    token: this.token
                }).then(res => {
                    self.channelOptions = res;
                })
            },
            showGifts(){
                let self = this;
                exchangeApi.showGifts({
                    token: this.token,
                    queryGiftForm:self.queryGiftForm,
                }).then(res =>{
                    self.gifts = res.content;
                    self.queryGiftForm.totalPages = res.totalPages;
                    self.queryGiftForm.totalElements = res.totalElements;
                })
            },
            createGift(){
                let self = this;
                exchangeApi.createGift({
                    token: self.token,
                    createGiftForm:self.createGiftForm
                }).then(res =>{
                    this.showGifts();
                })
            },
            deleteGift(id){
                let self = this;
                exchangeApi.deleteGift({
                    token: self.token,
                    id: id
                }).then(res =>{
                    this.showGifts();
                })
            },
            createSequence(){
                let self = this;
                exchangeApi.createSequence({
                    token: self.token,
                    createForm: self.createForm
                }).then(res =>{
                    this.showAllExchangeSequence();
                    self.queryCode()
                })
            },
            insertCodeBySequence(sequenceId){
                let self = this;
                exchangeApi.insertCodeBySequence({
                    token: self.token,
                    sequenceId: sequenceId
                }).then(res =>{
                    self.$message(res);
                    this.showAllExchangeSequence();
                })
            },
            exportSequence(id) {
                let self = this;
                exchangeApi.exportExcel({
                    token: self.token,
                    sequenceId: id
                }).then(res =>{
                  this.showAllExchangeSequence();
                })
            },
            banSequence(id) {
                let self = this;
                let listForm = [];
                listForm.push(id);

                self.banSequenceFun(listForm);
            },

            enabledSequence(id) {
                let self = this;
                let listForm = [];
                listForm.push(id);

                exchangeApi.enableSequence({
                    token: self.token,
                    listForm: listForm
                }).then(res => {
                    self.$message({
                        type: 'success',
                        message: "停用完毕"
                    })
                    self.showAllExchangeSequence();
                })
            },

            deleteSequence(id){
              let self = this;

              this.$confirm('此操作将永久废弃该批次生产的所有兑换吗,且兑换码无法兑换, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              }).then(() => {
                exchangeApi.deleteSequence({
                  token: self.token,
                  id: id
                }).then(res => {
                  self.$message({
                    type: 'success',
                    message: "删除完毕"
                  })
                  self.showAllExchangeSequence();
                })
              }).catch(() => {
                this.$message({
                  type: 'info',
                  message: '已取消删除'
                });
              });

            },

            updateSequence(id,remainCount,gmtEnd,exchangeType){
                this.updateSequenceForm.dialogVisible = true;
                this.updateSequenceForm.sequenceId = id;
                this.updateSequenceForm.remainCount = remainCount;
                this.updateSequenceForm.gmtEnd = gmtEnd;
                this.updateSequenceForm.exchangeType = exchangeType;
            },

            confirmUpdateSequence(){
                let self = this;

                exchangeApi.updateSequence({
                    token: self.token,
                    updateSequenceForm: self.updateSequenceForm
                }).then(res =>{
                    self.$message({
                        type: 'success',
                        message: "修改成功"
                    })
                    self.updateSequenceForm.dialogVisible = false
                    this.showAllExchangeSequence();
                })
            },
            async supplySequence(id) {
                let self = this;
                exchangeApi.supplyCode({
                    token: this.token,
                    id: id
                }).then(res => {

                    self.codeList = res.newList;
                    self.codesLen = res.newList.length;
                    let generatorCount = res.seq.totalCount - res.seq.activeCount;
                    //创建批量兑换码列表
                    let form = {
                        channel: res.seq.channel,
                        gmtValid: res.seq.gmtValid,
                        mark: res.seq.mark,
                        pici: res.seq.id,
                        rewards: res.seq.rewards,
                        subType: res.seq.subType,
                        totalCount: generatorCount,
                        type: res.seq.exchangeType,
                    };
                    self.asyncCreateCode(form);

                })
            },
            getExchangeCode() {
                let self = this;
                let len = self.queryForm.codeStr.trim();
                if (len <= 0) {
                    self.$message({
                        type: 'error',
                        message: "请填写正确的兑换码！！！"
                    })
                    return;
                }
                exchangeApi.findCode({
                    token: this.token,
                    codeStr: self.queryForm.codeStr
                }).then(res => {
                    self.codeData = res;
                })
            },
            handleQuerySequenceCurrentChange(){
                let self = this;
                self.showAllExchangeSequence()
            },
            handleQuerySequenceSizeChange(val) {
                this.showAllExchangeSequence()
            },
            handleQueryCodeCurrentChange(){
                let self = this;
                self.queryCode()
            },
            handleQueryCodeSizeChange(val) {
                this.queryCode();
            },
            handleQueryGiftCurrentChange(){
                this.showGifts();
            },
            handleQueryGiftSizeChange(val) {
                this.showGifts();
            },
            handleQueryExchangeCodeHistoryCurrentChange() {
                this.getUserExchangeHistory();
            },
            handleQueryExchangeCodeHistorySizeChange() {
                this.getUserExchangeHistory();
            },

            queryCode(){
                let self = this;

                exchangeApi.queryCode({
                    token: self.token,
                    queryCodeForm:self.queryCodeForm
                }).then(res => {
                    self.publicCodeList = res.content;
                    self.queryCodeForm.totalPages = res.totalPages;
                    self.queryCodeForm.totalElements = res.totalElements;
                })
            },
            sumExchangeCode() {
                let self = this;

                let sumForm = {
                    mode: self.queryForm.mode,
                    type: self.queryForm.codeType,
                }
                if (self.queryForm.mode == 'sumBySequence') {
                    sumForm.sequenceId = self.queryForm.sequenceId;

                } else if (self.queryForm.mode == 'sumByGift') {
                    sumForm.giftId = self.queryForm.giftId;

                } else if (self.queryForm.mode == 'sumByMark') {
                    sumForm.mark = self.queryForm.mark;
                }

                exchangeApi.sumCode({
                    sumForm: sumForm,
                    token: this.token
                }).then(res => {
                    self.codeSumData = res;
                })
            },
            banExchangeCode(id) {
                let self = this;
                exchangeApi.banCode({
                    id: id,
                    token: this.token
                }).then(res => {
                    self.$message({
                        type: 'success',
                        message: "废弃完毕"
                    })
                })
            },
            getUserExchangeHistory(){
              let self = this;
              exchangeApi.getExchangeHistory({
                  queryExchangeHistoryForm: self.queryExchangeHistoryForm,
                  token: self.token
              }).then(res => {
                    self.exchangeCodeHistory = res.content;
                    self.queryExchangeHistoryForm.totalPages = res.totalPages;
                    self.queryExchangeHistoryForm.totalElements = res.totalElements;
              })
            },

            banSequenceByPicis() {
                let listForm = codeSumData.picis;
                if (listForm.length <= 0) {
                    return;
                }
                this.banSequenceFun(listForm);
            },
            grabGeneratorCount() {
                let self = this;
                let generatorCount = 0;
                if (self.createForm.exchangeType == 1) {
                    generatorCount = 1;
                } else {
                    if (self.isDetail == false) {
                        generatorCount = self.createForm.totalCount;
                    } else {
                        generatorCount = self.num.a * 1 + self.num.b * 10 + self.num.c * 100 + self.num.d * 1000 + self
                            .num.e * 10000 + self.num.f * 100000;
                    }
                }
                return generatorCount;
            },
            addRewardGroup() {
                let rewardGroups = this.rewardGroups;
                rewardGroups.push([]);
                this.currentRewardGroupIdx = rewardGroups.length - 1;
                this.addReward();
            },

            selectReward(idx) {
                this.currentRewardIdx = idx;
                this.currentReward = this.rewardGroups[this.currentRewardGroupIdx][idx];
            },

            addReward() {
                let rewards = this.rewardGroups[this.currentRewardGroupIdx];
                rewards.push([]);
                this.selectReward(rewards.length - 1);
            },

            deleteReward() {
                let rewards = this.rewardGroups[this.currentRewardGroupIdx];
                let len = rewards.length;
                if (len > 1) {
                    let idx = this.currentRewardIdx;
                    rewards.splice(idx, 1);
                    this.finalContentCNArr.splice(idx, 1);
                    this.selectReward(idx >= len - 1 ? len - 2 : idx);
                }
            },

            getReward(mainReward, idx, finalContentCN) {
                this.currentRewardIdx = idx;
                this.rewardGroups[this.currentRewardGroupIdx][idx] = mainReward;
                this.currentReward = this.rewardGroups[this.currentRewardGroupIdx][idx];

                this.finalContentCNArr[idx] = finalContentCN;

                this.createForm.rewards = this.rewardGroups[0].join(',');
            },
            async codeGenerator() {

                // setTimeout(() => {
                //
                // }, 2000);
                let self = this;
                if (self.createForm.exchangeType != 1) {
                    let len = self.createForm.pici.trim().length;
                    if (len < 3 || len > 4) {
                        self.$message({
                            type: 'error',
                            message: "批次在3至4个字符以内(字母和数字组合)"
                        })
                        return;
                    }
                } else {
                    let len = self.createForm.textCode.trim().length;
                    if (len < 1 || len > 20) {
                        self.$message({
                            type: 'error',
                            message: "公共兑换码在1至20个字以内"
                        })
                        return;
                    }
                    self.createForm.pici = self.createForm.textCode;
                    self.createForm.mark = self.createForm.textCode;
                    self.createForm.subType = self.createForm.textCode;
                }

                let generatorCount = self.grabGeneratorCount();

                exchangeApi.createSequence({
                    createForm: {
                        channel: self.createForm.channel,
                        gmtValid: self.createForm.gmtValid,
                        mark: self.createForm.mark,
                        pici: self.createForm.pici,
                        rewards: self.createForm.rewards,
                        subType: self.createForm.subType,
                        totalCount: generatorCount,
                        type: self.createForm.exchangeType,
                        textCode: self.createForm.textCode
                    },
                    token: this.token
                }).then(res => {
                    self.sequence = res.seq;
                    if (self.createForm.exchangeType == 1) {
                        self.$message({
                            type: 'success',
                            message: "生成完毕"
                        })
                    } else {
                        self.codeList = res.newList;
                        self.codesLen = res.newList.length;
                        let generatorCount = self.grabGeneratorCount();
                        //创建批量兑换码列表
                        let form = {
                            channel: self.createForm.channel,
                            gmtValid: self.createForm.gmtValid,
                            mark: self.createForm.mark,
                            pici: self.createForm.pici,
                            rewards: self.createForm.rewards,
                            subType: self.createForm.subType,
                            totalCount: generatorCount,
                            type: self.createForm.exchangeType,
                        };

                        self.asyncCreateCode(form);
                    }
                })
            },
            asyncCreateCode(createForm) {
                const loading = this.$loading({
                    lock: false,
                    text: 'Loading',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                let self = this;
                self.codeIndex++;
                if (self.codeIndex < self.codesLen) {
                    let codes = self.codeList[self.codeIndex];
                    if (codes.length > 0) {
                        createForm.codes = codes;
                        createForm.createIndex = self.codeIndex;
                        self.createCode(createForm).then(function(data) {
                            self.asyncCreateCode(createForm) //这里做递归
                        })
                    } else {
                        self.asyncCreateCode(createForm) //这里做递归
                    }
                } else if (self.codeIndex == self.codesLen) {
                    loading.close();
                    self.$message({
                        type: 'success',
                        message: "生成完毕"
                    })
                }
            },
            createCode() {
                let self = this;
                exchangeApi.createCode({
                    createForm: self.createForm,
                    token: self.token
                }).then(res => {
                    self.queryCode();
                })
            },
            banSequenceFun(listForm) {
                let self = this;
                exchangeApi.banSequence({
                    token: self.token,
                    listForm: listForm
                }).then(res => {
                    self.$message({
                        type: 'success',
                        message: "停用完毕"
                    })
                    self.showAllExchangeSequence();
                })
            },

            rewardsToCN(rewards,id) {
                var arr = rewards.split(',');
                var result = '';
                arr.forEach(item => {
                    if (item !== '') {
                        this.resolveRewardStr(item);

                        let optionValueCN = this.optionMap[this.optionValue];
                        let idCn = this.getIdCn(this.optionValue,this.value);
                        let finalCount = '';
                        if (this.countSwitch) {
                            finalCount = this.count1 + "-" + this.count2;
                        } else {
                            finalCount = this.count1
                        }
                        let finalContentCN = optionValueCN + "$" + idCn + "_" + finalCount;
                        result = result + (result?',':'') + finalContentCN;
                    }

                })

                this.rewardsCN = result;
                this.rewardsCNId = id;
            },

            resolveRewardStr(str){
                let self = this;

                if (str == '') {
                    self.countSwitch = false;
                    self.rateSwitch = false;
                    self.isDetail = false;
                    self.count1 = 1;
                    self.count2 = 1;
                    self.rate = 0.1;
                    self.emblemLevel = 1;
                    self.emblemStage = 0;
                    self.emblemQuality = 1;
                    self.emblemMainProperty = 1;
                    self.emblemFate = 0;
                    self.emblemFateCustomize = 100;
                    self.emblemFateProperty = 51;

                    self.editEmblemEntries = [
                        {
                            entry:[3, 0],
                            quality:0,
                            active:true
                        },
                        {
                            entry:[3, 0],
                            quality:0,
                            active:false
                        },
                        {
                            entry:[3, 0],
                            quality:0,
                            active:false
                        },
                        {
                            entry:[3, 0],
                            quality:0,
                            active:false
                        },
                        {
                            entry:[3, 0],
                            quality:0,
                            active:false
                        },
                        {
                            entry:[3, 0],
                            quality:0,
                            active:false
                        },
                    ]
                }

                let rewardArray = str.toString().split("_");

                for (let index = 0; index < rewardArray.length; index++) {
                    const element = rewardArray[index];
                    switch (index) {
                        case 0:
                            let bigTypeArry = element.split("$");
                            //大类
                            self.optionValue = bigTypeArry[0];
                            //identify
                            self.value = parseInt(bigTypeArry[1]);
                            if (self.value == 50001) {
                                self.emblemRandomByQuality = false;
                            } else {
                                self.emblemRandomByQuality = true;
                            }
                            break;
                        case 1:
                            //数量
                            let countArry = element.split("-");
                            if(countArry.length>1){
                                self.countSwitch = true;
                                self.count1 = countArry[0];
                                let rateAndCount = countArry[1].split('|');
                                if (rateAndCount.length>1) {
                                    self.rateSwitch = true;
                                    self.count2 = rateAndCount[0];
                                    self.rate = rateAndCount[1];
                                } else {
                                    self.rateSwitch = false;
                                    self.count2 = countArry[1];
                                }
                            }else{
                                self.countSwitch = false;

                                let rateAndCount = countArry[0].split('|');
                                if (rateAndCount.length>1) {
                                    self.rateSwitch = true;
                                    self.count1 = rateAndCount[0];
                                    self.rate = rateAndCount[1];
                                } else {
                                    self.rateSwitch = false;
                                    self.count1 = countArry[0];
                                }
                            }
                            break;
                        case 2:
                            //等级
                            self.emblemLevel = parseInt(element);

                            if (self.optionValue == '7') {
                                self.warGrooveQuality = parseInt(element);
                            }
                            break;
                        case 3:
                            //阶段
                            self.emblemStage = parseInt(element);

                            if (self.optionValue == '7') {
                                if (element) {
                                    self.warGrooveChannelSwitch = true;
                                    self.warGrooveChannelUp = parseInt(element);
                                } else {
                                    self.warGrooveChannelSwitch = false;
                                }
                            }
                            break;
                        case 4:
                            //品质
                            self.emblemQuality = parseInt(element);

                            if (self.optionValue == '7') {
                                self.warGrooveChannelDown = parseInt(element);
                            }
                            break;
                        case 5:
                            //宿命
                            let fateArray = element.split("#");
                            self.emblemFate = 3;
                            if(fateArray.length>1){
                                for (let i = 0; i < fateArray.length; i++) {
                                    const element = fateArray[i];
                                    let item = fateArray.splice("@");
                                    self.emblemFateCustomizeTags[i] = {id:parseInt(item[0]),chance:parseInt(item[1])}
                                }
                            }else{
                                if(element>0){
                                    self.emblemFate = 2;
                                    self.emblemFateProperty = parseInt(element);
                                }else{
                                    self.emblemFate = 0;
                                }
                            }

                            if (self.optionValue == '7') {
                                self.warGrooveChannelLeft = parseInt(element);
                            }

                            break;
                        case 6:
                            //宿命自定义概率
                            self.emblemFateCustomize = parseInt(element*100);

                            if (self.optionValue == '7') {
                                self.warGrooveChannelRight = parseInt(element);
                            }
                            break;
                        case 7:
                            //主属性
                            self.emblemMainProperty = parseInt(element);
                            break;
                        case 8:
                            //词条属性
                            let entryArray = element.split("#");
                            for (let index = 0; index < entryArray.length; index++) {
                                const entryItem = entryArray[index];
                                let current = self.editEmblemEntries[index];

                                self.emblemEntryConfigs.forEach(item => {
                                    item.children.forEach(iitem => {
                                        if (iitem.value == entryArray[index].split('@')[0]&&entryArray[index].split('@').length>1) {
                                            self.editEmblemEntries[index].entry = [item.value,iitem.value];
                                            self.editEmblemEntries[index].active = true;
                                        } else {
                                            self.editEmblemEntries[index].active = false;
                                        }
                                    })
                                })

                                self.editEmblemEntries[index].quality = parseInt(entryArray[index].split('@')[1]);
                            }

                            let countAndEntry = entryArray[entryArray.length-1].split('|');
                            if (countAndEntry.length>1) {
                                self.rateSwitch = true;
                                self.rate = countAndEntry[1];
                            } else {
                                self.rateSwitch = false;
                            }
                            break;
                        default:
                            break;
                    }
                }
            },

            getIdCn(optionValue,id){
                let self = this;
                if(optionValue == "0" || optionValue == "3" || optionValue == "4" || optionValue == "5" || optionValue == "9" || optionValue == "10" || optionValue == "11" || optionValue == "12" || optionValue == "13" || optionValue == "14" || optionValue == "15"){
                    //道具
                    return self.$t('propConfigName_'+id);
                }else if(optionValue == "1"){
                    //怪兽
                    return self.$t('monsterName_' + id);
                }else if(optionValue == "2"){
                    //怪兽碎片
                    return self.$t('monsterName_' + ((id>>0)-10000)) + "碎片";
                }else if(optionValue == "6"){
                    //怪兽觉醒水晶
                    return self.$t('monsterName_' + ((id>>0)-20000)) + "觉醒结晶";
                }else if(optionValue == "8"){
                    //怪兽觉醒水晶碎片
                    return self.$t('monsterName_' + ((id>>0)-30000)) + "觉醒结晶碎片";
                }else if(optionValue == "7"){
                    //战纹
                    return self.$t('warGrooveConfigName_' + id);
                }
            },
            generateRewardData() {
                var data = this.rewardGroups;
                for (var i=0;i<data.length;i++) {
                    for (var j=0;j<data[i].length;j++) {
                        if (data[i][j].length<=0) {
                            data[i].splice(j,1);
                            j = j-1;
                        }
                    }
                    if (data[i].length<=0) {
                        data.splice(i,1);
                        i = i-1;
                    }
                }

                data.forEach(item => {
                    item.join(',')
                })

                data = data.join(';');
                this.rewardStr = data;
            },
        }
    }
</script>

<style lang="less" scoped>
    .confirm-btn {
        text-align: center;
        margin-top: 50px;
    }

    .el-card {
        margin: 20px 0 !important;
    }
    .player-form label {
        color: #99a9bf;
        width: 125rem;
    }

    .reward-text {
        color: #5daf34;
    }

    .code-tip {
        color: red;
    }
</style>



// WEBPACK FOOTER //
// src/views/activity_gift/gift_exchange_code.vue